import { NDLKotenOCR } from '../ndl-koten-ocr';
import type { ProcessOptions, ProcessResult, SimpleInitOptions } from '../ndl-koten-ocr';

interface WorkerMessage {
  type: 'init' | 'process';
  id: string;
  data?: any;
}

interface InitMessage extends WorkerMessage {
  type: 'init';
  data: SimpleInitOptions;
}

interface ProcessMessage extends WorkerMessage {
  type: 'process';
  data: {
    imageData: ImageData;
    options?: ProcessOptions;
  };
}

interface WorkerResponse {
  type: 'success' | 'error' | 'progress';
  id: string;
  data?: any;
  error?: string;
}

let ocr: NDLKotenOCR | null = null;

self.addEventListener('message', async (event: MessageEvent<WorkerMessage>) => {
  const { type, id, data } = event.data;

  try {
    switch (type) {
      case 'init':
        const initData = data as SimpleInitOptions;

        // プログレスコールバックをWorker経由で送信
        const progressCallback = initData.progressCallback ?
          (progress: number, message: string) => {
            self.postMessage({
              type: 'progress',
              id,
              data: { progress, message }
            } as WorkerResponse);
          } : undefined;

        ocr = new NDLKotenOCR();
        await ocr.init({
          ...initData,
          progressCallback
        });

        self.postMessage({
          type: 'success',
          id,
          data: { initialized: true }
        } as WorkerResponse);
        break;

      case 'process':
        if (!ocr) {
          throw new Error('OCR not initialized. Call init() first.');
        }

        const processData = data as ProcessMessage['data'];

        // プログレスコールバックをWorker経由で送信
        const onProgress = processData.options?.onProgress ?
          (progress: number, message: string) => {
            self.postMessage({
              type: 'progress',
              id,
              data: { progress, message }
            } as WorkerResponse);
          } : undefined;

        const result = await ocr.process(processData.imageData, {
          ...processData.options,
          onProgress
        });

        self.postMessage({
          type: 'success',
          id,
          data: result
        } as WorkerResponse);
        break;

      default:
        throw new Error(`Unknown message type: ${type}`);
    }
  } catch (error) {
    self.postMessage({
      type: 'error',
      id,
      error: error instanceof Error ? error.message : String(error)
    } as WorkerResponse);
  }
});

// TypeScriptのWorker用エクスポート
export default null;